module.exports = __webpack_public_path__ + "img/tips3list4img19120305.c94e8ed5.jpg";